import React, { useMemo, memo } from "react"
import Box from "@material-ui/core/Box"
import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles((theme) => ({
    progressBarWrapper: {
        position: "relative",
        height: "15px",
        marginBottom: theme.spacing(2),
    },
    progressBarLabel: {},
    progressBarGroove: {
        width: "100%",
        backgroundColor: "currentColor",
        opacity: "0.1",
        position: "absolute",
        height: "100%",
    },
    progressBarProgress: {
        position: "absolute",
        top: 0,
        left: 0,
        height: "100%",
        transition: "width 150ms ease-out, background-color 2s ease-out",
        width: ({ percent }) => {
            return `${percent}%`
        },
        backgroundColor: ({ percent }) => {
            if (percent <= 33) {
                return "#f21c20"
            }
            if (percent > 33 && percent < 66) {
                return "#ed9e14"
            }
            if (percent >= 66 && percent < 100) {
                return "#52b9e9"
            }
            return "#1bd422"
        },
    },
}))

const ProgressBarLine = memo((props) => {
    const { progress, outOf } = props

    const percent = useMemo(() => {
        return progress > 0 ? Math.round((progress / outOf) * 100) : 0
    }, [progress, outOf])

    const styleProps = {
        percent,
    }

    const classes = useStyles(styleProps)

    return (
        <Box>
            <Box className={classes.progressBarWrapper}>
                <Box className={classes.progressBarGroove} />
                <Box className={classes.progressBarProgress} />
            </Box>
        </Box>
    )
})

export default ProgressBarLine
